import HeaderSection from './components/HeaderSection';
import AboutSection from './components/AboutSection';
import ProductsSection from './components/ProductsSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import FooterBar from './components/FooterBar';

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <HeaderSection />
      <AboutSection />
      <ProductsSection />
      <FeaturesSection />
      <ContactSection />
      <FooterBar />
    </main>
  );
}
